import { IMenuEditModel } from 'AppTypes'

import axios from '@utils/axios-client'

export function fetchMenuProfile (params: any) {
  return axios.get('/api/v1/MenuOfStore', { params }).then(response => response.data)
}

export function fetchMenuTypes (params: any) {
  return axios.get('/api/v1/MenuType/MenuTypeOfStore', { params }).then(response => response.data)
}

export function changeMenuProfileStatus (isPublic: boolean) {
  return new Promise<boolean>(resolve => {
    resolve(isPublic)
  })
}

export function createMenu (menu: IMenuEditModel) {
  return axios.post('/api/v1/MenuOfStore', menu)
    .then(() => true)
    .catch(() => false)
}

export function deleteMenu (menuId: number) {
  return axios.delete(`/api/v1/MenuOfStore/${menuId}`)
}

export function fetchMenuById (id: string) {
  return axios.get(`/api/v1/MenuOfStore/${id}`).then(response => response.data)
}

export function updateMenu (item: IMenuEditModel) {
  return axios.put(`/api/v1/MenuOfStore/${item.id}`, item)
    .then(() => true)
    .catch(() => false)
}
